//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-payable/reports/detailed-aged';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            headers: ['Vendor', 'Invoice Number', { title: 'Invoice Amount', filter: 'toCurrency' }, 'Invoice Due Date', 'GL Cash Account', 'Accounting Code', { title: 'Invoice Line Item Amount', filter: 'toCurrency' }, 'Invoice Line Item Description', 'Invoice Has Rehab Item?'],
            fields: ['Vendor', 'Invoice Number', 'Invoice Amount', 'Invoice Due Date', 'GL Cash Account', 'Accounting Code', 'Invoice Line Item Amount', 'Invoice Line Item Description', 'Invoice Has Rehab Item?'],
            items: [],
            showRehabOnly: false,
            loading: true
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('ap-detailed-aged-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportAgedDetailedApToExcel', function () {
            return _this.exportToExcel();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ap-detailed-aged-report');
        Event.$off('exportAgedDetailedApToExcel');
    },

    methods: {
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                exportExcel: true,
                showRehabOnly: this.showRehabOnly
            };
            var now = new Date().toISOString().substring(0, 10);
            this.createExport(data, '' + BASE_URL, 'Aged Detailed AP Report ' + now, '.xlsx');

            this.loading = false;
        },
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;

            // build payload
            var data = {
                showRehabOnly: this.showRehabOnly
            };

            axios.post('' + BASE_URL, data).then(function (response) {
                _this2.items = response.data;
                _this2.loading = false;
            });
        }
    },
    computed: {
        filteredData: function filteredData() {
            if (this.showRehabOnly) {
                return this.items.filter(function (invoice) {
                    return invoice['Invoice Has Rehab Item?'] != 'No';
                });
            } else {
                return this.items;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/reports/ApDetailedAgedReport.vue
// module id = i+3u
// module chunks = 0 1